<div [hidden]="totalCars <= 0 && hideIfEmpty" class="flex-350px">
  <div class="bigger-font-size">{{ 'reports.filterLabel.dateRange'  | translate }}</div>
  <div class="flex-row vid-component-wrapper">
    <div class="canvas-dimensions">
      <canvas #chartVID></canvas>
    </div>
    <div class="flex-column">
      <mat-form-field subscriptSizing="dynamic" class="background-color-whitesmoke">
        <mat-label>{{ 'dashboard.enterDateRange' | translate }}</mat-label>
        <mat-date-range-input [rangePicker]="carBodyPicker" [min]="initMinimumDate" [max]="initMaximumDate">
          <input matStartDate placeholder="Start date" [(ngModel)]="startDate">
          <input matEndDate placeholder="End date" [(ngModel)]="endDate" (dateChange)="dateRangeChange()">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="carBodyPicker"></mat-datepicker-toggle>
        <mat-date-range-picker #carBodyPicker></mat-date-range-picker>
      </mat-form-field>
      <p [hidden]="totalCars <= 0" class="cars-total bigger-font-size" (click)="showVidVehicleDialog(0, 2)">#{{ productType }} {{ totalCars }}</p>
    </div>
  </div>
</div>
